import { connect } from "vuex-connect";
// import log from 'loglevel';
import { SharePostComicStepper } from "../../../components";

export default connect({
  stateToProps: {
    draftId: state => state.uploadContents.draftId,
    pageProgressionDirection: state =>
      state.uploadContents.pageProgressionDirection,
    isBusy: state => state.common.isBusy,
    images: state => state.uploadContents.images,
    defaultThumbnailOriginalImageUrl: state =>
      state.uploadContents.defaultThumbnailOriginalImageUrl,
    defaultOriginalSocialMediaImageUrl: state =>
      state.uploadContents.defaultOriginalSocialMediaImageUrl,
    defaultFrontCoverImageUrl: state =>
      state.uploadContents.defaultFrontCoverImageUrl,
    userFrontCoverImageUrl: state =>
      state.uploadContents.userFrontCoverImageUrl,
    frontCoverType: state => state.uploadContents.frontCoverType,
    stepNumber: state => state.uploadContents.stepNumber,
    isPanel: state => state.common.isPanel,
    defaultSpineImageUrl: state => state.uploadContents.defaultSpineImageUrl
  },
  gettersToProps: {
    enablePostStep1: "uploadContents/enablePostStep1",
    enablePostStep2: "uploadContents/enablePostStep2",
    enablePostStep3: "uploadContents/enablePostStep3",
    getNotIncludeCoverDataImageCount:
      "uploadContents/getNotIncludeCoverDataImageCount",
    spineImageWidthMM: "uploadContents/spineImageWidthMM",
    spineImageHeightMM: "uploadContents/spineImageHeightMM",
    spineImageUrl: "uploadContents/spineImageUrl"
  },
  actionsToProps: {
    postDraft: (dispatch, value) => dispatch("uploadContents/postDraft", value),
    putDraft: (dispatch, value) => dispatch("uploadContents/putDraft", value),
    publish: (dispatch, value) => dispatch("uploadContents/publish", value),
    publishProgress: (dispatch, value) =>
      dispatch("uploadContents/publishProgress", value),
    postDefaultThumbnailImage: (dispatch, value) =>
      dispatch("uploadContents/postDefaultThumbnailImage", value),
    postDefaultSocialMediaImage: (dispatch, value) =>
      dispatch("uploadContents/postDefaultSocialMediaImage", value),
    getIceContentsInitialSettings: dispatch =>
      dispatch("uploadContents/getIceContentsInitialSettings"),
    updateHybrid3dSettings: dispatch =>
      dispatch("uploadContents/updateHybrid3dSettings"),
    postDefaultSpineImage: (dispatch, value) =>
      dispatch("uploadContents/postDefaultSpineImage", value),
    deleteDefaultSpineImage: (dispatch, value) =>
      dispatch("uploadContents/deleteDefaultSpineImage", value)
  },
  mutationsToProps: {
    setIsBusy: "common/setIsBusy",
    setIsPanel: "common/setIsPanel",
    updateDraftId: (commit, value) =>
      commit("uploadContents/updateDraftId", value),
    updateJwt: (commit, value) => commit("uploadContents/updateJwt", value),
    updateIsSecureView: "uploadContents/updateIsSecureView",
    updateTitle: (commit, value) => commit("uploadContents/updateTitle", value),
    updateIsDefaultHybrid3d: (commit, value) =>
      commit("uploadContents/updateIsDefaultHybrid3d", value),
    updateDefaultThumbnailOriginalImageUrl: (commit, value) =>
      commit("uploadContents/updateDefaultThumbnailOriginalImageUrl", value),
    updateDefaultOriginalSocialMediaImageUrl: (commit, value) =>
      commit("uploadContents/updateDefaultOriginalSocialMediaImageUrl", value),
    updateDefaultSpineImageUrl: (commit, value) =>
      commit("uploadContents/updateDefaultSpineImageUrl", value),
    updateIsUploadIceContents: (commit, value) =>
      commit("uploadContents/updateIsUploadIceContents", value),
    updateSize: (commit, value) => commit("uploadContents/updateSize", value),
    updateSizeSelect: (commit, value) =>
      commit("uploadContents/updateSizeSelect", value),
    updateIceContentsPageCount: (commit, value) =>
      commit("uploadContents/updateIceContentsPageCount", value),
    updateIceContentsHasCover: (commit, value) =>
      commit("uploadContents/updateIceContentsHasCover", value),
    updateFrontCoverImageWidth: (commit, value) =>
      commit("uploadContents/updateFrontCoverImageWidth", value),
    updateFrontCoverImageHeight: (commit, value) =>
      commit("uploadContents/updateFrontCoverImageHeight", value),
    updateStepNumber: (commit, value) =>
      commit("uploadContents/updateStepNumber", value)
  }
})(SharePostComicStepper.name, SharePostComicStepper);
